export function addImagePrefix(content: string): string {
  // Simple regex to match specific image domains in URLs
  return content.replace(
    /(https?:\/\/)(s3-alpha-sig\.figma\.com|placehold\.co|randomuser\.me|githubusercontent\.com)([^\s"')]+)/g,
    'https://img-wrapper.vercel.app/image?url=$1$2$3',
  );
}

export function removeMarkdownBackticks(content: string): string {
  const languages = ['typescript', 'javascript', 'json', 'yaml', 'html', 'css', 'scss', 'text'];

  for (const language of languages) {
    if (content.startsWith(`\`\`\`${language}`)) {
      console.log('cleaned with first condition');
      return content.substring(`\`\`\`${language}`.length, content.length - 3).trim();
    }
  }

  // Check if content starts with ``` and ends with ```
  if (content.startsWith('```') && content.endsWith('```')) {
    // Find the first newline to skip the language identifier line
    const firstNewlineIndex = content.indexOf('\n');

    if (firstNewlineIndex !== -1) {
      // Return content between the first newline and the last ```
      return content.substring(firstNewlineIndex + 1, content.length - 3).trim();
    }
  }

  // If not in the expected format, return the original content
  return content;
}

export function replaceBoltWithDualite(content: string): string {
  return content.replace(/boltArtifact/g, 'dualiteArtifact').replace(/boltAction/g, 'dualiteAction');
}
